import { mapGetters } from 'vuex';

/**
 * Brand-aware asset picking. Components that ship a Sanne-specific image
 * (logo, illustration, single-colour icon copy) import both files and call
 * `brandAsset(defaultAsset, sanneAsset)`; the default brand keeps its file
 * untouched. Same pattern as the `isIncein ? a : b` switches in the Stamp
 * components, just centralised so the getter is not re-mapped everywhere.
 */
const brandMode = {
  computed: {
    ...mapGetters('app', ['isSanne']),
  },
  methods: {
    brandAsset(defaultAsset, sanneAsset) {
      return this.isSanne && sanneAsset ? sanneAsset : defaultAsset;
    },
  },
};

export default brandMode;
